import React from 'react'
import styled from 'shared/theme'

export const FORCE_CWR_URL = 'https://cwr-force.metadata.dmed.technology/'

const Notice = styled.p<{ $variant: 'header' | 'standalone' }>`
    margin: ${({ $variant }) => ($variant === 'header' ? '0' : '0 auto 2rem')};
    max-width: 42rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
    text-align: center;
    color: ${props => props.theme.colors.textSecondary};
`

const NoticeLink = styled.a`
    color: ${props => props.theme.colors.textSecondary};
    text-decoration: underline;
`

const FutureLine = styled.span`
    display: block;
    margin-top: 0.25rem;
`

type MigrationNoticeProps = {
    variant?: 'header' | 'standalone'
}

const MigrationNotice: React.FC<MigrationNoticeProps> = ({ variant = 'header' }) => (
    <Notice $variant={variant}>
        Please update your bookmarks and access the new CWR UI via this URL:{' '}
        <NoticeLink href={FORCE_CWR_URL} target="_blank" rel="noopener noreferrer">
            https://cwr-force.metadata.dmed.technology
        </NoticeLink>
        <FutureLine>In the future, you will be automatically redirected to the new UI.</FutureLine>
    </Notice>
)

export default MigrationNotice
